export default __webpack_public_path__ + "static/media/vpn.3e0ddae4.svg";